import React, { Component } from "react";
class NotFound extends Component {
  state = {};
  render() {
    return (
      <div style={{ marginTop: "20%", textAlign: "center" }}>
        <h1>404 Page Not Found </h1>
      </div>
    );
  }
}

export default NotFound;
